export const AccessDenied = () => {
    return(<div>
        Access Denied
    </div>)
}